/**
 * Funktion um langsam ein Element ein- und auszublenden
 * damit es korrekt funktioniert braucht das Element eine CSS Transition
 * overflow: hidden;
 * max-height: 0;
 * transition: max-height 0.5s ease;
 */
export class OpenHideEffekt {
    // Funktion zum Slide-Down mit CSS Transition
    public slideDown(element: HTMLElement) {
        element.style.display = "block";
        const height = element.scrollHeight + "px";
        element.style.maxHeight = "0";
        setTimeout(() => {
            element.style.transition = "max-height 0.5s ease";
            element.style.maxHeight = height;
        }, 10);
    }

    // Funktion zum Slide-Up mit CSS Transition
    public slideUp(element: HTMLElement) {
        element.style.transition = "max-height 0.5s ease";
        element.style.maxHeight = "0";
        setTimeout(() => {
            element.style.display = "none";
        }, 500);
    }
}
